import React, { FC } from 'react'

import { TypeMenuItem } from '@widgets/Restaurant/RestMenuItem/types/menu'

import { ErrorBoundary } from '@shared/lib/components/ErrorBoundary'
import { SectionCarousel } from '@shared/ui/Layout/SectionCarousel'
import { RestMenuItem } from '@widgets/Restaurant/RestMenuItem'
import useFeatureFlag from '@shared/lib/hooks/useFeatureFlag'

interface Props {
  data: TypeMenuItem[]
  restPath: string
  className?: string
}

const RestItemMenu: FC<Props & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>> = ({
  data,
  restPath,
  className = '',
  ...props
}) => {
  const isFeatureActive = useFeatureFlag('kuper')
  const items = data.filter((el) => {
    if (el.type === 'delivery' && !isFeatureActive) return false
    return true
  })

  return (
    <ErrorBoundary>
      <SectionCarousel
        countSlidesOnContainer={3}
        title={'Меню'}
        className={className}
        link={isFeatureActive ? restPath + '/menu/' : null}
        {...props}>
        <SectionCarousel.Items>
          {items.map((el, index) => (
            <RestMenuItem sizes={'298x92 261x86'} key={el.id} {...el} analytic={{ section_index: index }} />
          ))}
        </SectionCarousel.Items>
      </SectionCarousel>
    </ErrorBoundary>
  )
}

export default RestItemMenu
